var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#explore_svg__clip0_134_189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zM3 16C3 8.82 8.82 3 16 3c3.424 0 6.538 1.325 8.86 3.488L12 12 6.488 24.86A12.952 12.952 0 013 16zm15.286 2.286l-8.003 3.43 3.43-8.003 4.573 4.573zM16 29a12.955 12.955 0 01-8.86-3.488L20 20l5.512-12.86A12.952 12.952 0 0129 16c0 7.18-5.82 13-13 13z",
    fill: props.color || 'black'
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "explore_svg__clip0_134_189"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
export default SvgExplore;